import React from 'react';

import PageHeader, { PageBackground } from '@domain/page-header';
import LoginForm from '@features/login/login-form';
import { useLogin } from '@services/auth';
import { isDev } from '@utils/is-dev';

function Login() {
  const { mutateAsync: loginMutate, isPending } = useLogin();

  const onSubmit = async ({
    username,
    password
  }: {
    username: string;
    password: string;
  }) => {
    try {
      await loginMutate({ username, password });
    } catch (e) {}
  };

  return (
    <PageBackground>
      <PageHeader />
      <LoginForm
        onSubmit={onSubmit}
        isPending={isPending}
        defaultValues={
          isDev ? { username: 'KBU.VISITOR', password: 'Visitor01' } : undefined
        }
      />
    </PageBackground>
  );
}

export default Login;
